import React from "react";

//Images
import estimate from "../images/how-it-works/document.svg";
import design from "../images/how-it-works/graphic-design.svg";
import construction from "../images/how-it-works/jackhammer.svg";

const HowItWorks = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 panel-how-it-works">
        <div className="row">
          <div className="col-12 text-center">
            <h3 className="text-uppercase text-blue mb-3">How It Works</h3>
          </div>
        </div>
        <div className="row justify-content-around">
          <div className="col-10 col-lg-4 col-xl-3 text-center">
            <div className="image mt-3">
              <img src={estimate} alt="Free Estimate" />
            </div>
            <h4 className="text-uppercase">Free Estimate</h4>
            <p>
              The first step is to receive a free consultation to go over your
              needs and determine what the project will cost. We are expert
              estimators, so the price you’re given is what you’ll pay. We
              design within your budget, so no matter what you’re looking to
              spend, we can create the perfect outdoor space for you whether you
              want a new driveway, a patio, or a new pool deck.
            </p>
          </div>
          <div className="col-10 col-lg-4 col-xl-3 text-center">
            <div className="image mt-3">
              <img src={design} alt="Conceptual Design" />
            </div>
            <h4 className="text-uppercase">Conceptual Design</h4>
            <p>
              A conceptual design is completed according to the measurements of
              the space you have available and the types of stone being used.
              The design is then brought back to you for review and changes are
              made until you’re 100% satisfied.
            </p>
          </div>
          <div className="col-10 col-lg-4 col-xl-3 text-center">
            <div className="image mt-3">
              <img src={construction} alt="Construction" />
            </div>
            <h4 className="text-uppercase">Construction</h4>
            <p>
              After the design is approved, it’s time to get to work. We train
              every one of our employees to the highest standards. Our pavers
              installation crews are professional, courteous, and will ensure
              you’re completely satisfied at all times during installation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
